<template lang="html">
    <article class="media">
      <div class="media-content">
        <div class="content">
          <p>
            <strong>Senior Infrastructure Engineer</strong> | CrossnoKaye - <small>May 2023 - present</small>
            <br>
            Architecting network security, connectivity, configuration management, identity management and continuous software delivery for the Industrial IoT edge.
            </p>
        </div>
      </div>
    </article>
  </template>
  
  <script>
  export default {
    name: "crossnokaye"
  }
  </script>
  
  <style lang="css">
  </style>
  


// WEBPACK FOOTER //
// src/components/jobs/CrossnoKaye.vue